module.exports = __webpack_public_path__ + "static/vegetace1-6a55c8a41e118d1234366a4731be6bfe.jpg";